module.exports = __webpack_public_path__ + "static/krp-logo-0fdf38e36bbbea074be51a7d760c5303.jpg";